import { useLocation, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useUser } from '../../api/user/useUser';
import { ONBOARDING_REQUIRED_USER_SOURCES } from '../../config';
import { useLandingRoute } from '../../hooks/useLandingRoute';
import { ROUTE } from '../../routes';
import { useNavigation } from '@helios/frontend-core';

export const LOGIN_REDIRECT_KEY = 'loginRedirect';

export const useAuthRedirect = () => {
  const { isLoading: isLoadingUser, user, isAuthenticated, isAuthLoading } = useUser();
  const { openURL } = useNavigation();
  const { pathname } = useLocation();
  const landingRoute = useLandingRoute();
  const { existingProjectId, onboardingTimeout, finalizingVerification } = useSearch({ strict: false }) as {
    existingProjectId?: string;
    onboardingTimeout?: boolean;
    finalizingVerification?: boolean;
  };

  useEffect(() => {
    if (isAuthLoading || isLoadingUser) {
      return;
    }

    const loginRedirect = window.localStorage.getItem(LOGIN_REDIRECT_KEY);

    const isIncompleteOnboardingUser =
      !user?.propertyIds?.[0] &&
      user?.source &&
      ONBOARDING_REQUIRED_USER_SOURCES.has(user.source) &&
      pathname &&
      pathname !== ROUTE.ONBOARDING;

    const shouldSeeProjectOnboarding = user?.settings?.shouldSeeProjectOnboarding;

    if (!isAuthenticated) {
      openURL(ROUTE.LOGIN_SIGNUP_CHOICE);
    } else if (loginRedirect) {
      if (loginRedirect.indexOf('/') === 0) {
        openURL(loginRedirect);
      }
      window.localStorage.removeItem(LOGIN_REDIRECT_KEY);
    } else if (shouldSeeProjectOnboarding) {
      openURL(ROUTE.WELCOME);
    } else if (existingProjectId) {
      const searchParams = finalizingVerification
        ? { finalizingVerification: true }
        : onboardingTimeout
        ? { onboardingTimeout: true }
        : { existingProject: true };
      openURL({ to: ROUTE.PROJECT_DETAIL, params: { id: existingProjectId }, search: searchParams });
    } else if (isIncompleteOnboardingUser) {
      openURL(ROUTE.ONBOARDING);
    } else {
      openURL(landingRoute);
    }
  }, [isAuthenticated, isLoadingUser, existingProjectId, isAuthLoading]);
};
